package nl.volleyplanner.api

import kotlinx.serialization.Serializable

@Serializable
data class InviteOrganisationUserRequest(val email: String, val name: String)

@Serializable
data class InviteOrganisationUserResponse(val email: String, val token: String)

@Serializable
data class InviteRefreshRequest(val email: String)

@Serializable
data class OrganisationUserInvite(
    val organisationName: String,
    val email: String,
    val name: String,
    val token: String,
    val authUserExists: Boolean
)

@Serializable
data class AcceptUserInviteRequest(
    val email: String,
    val token: String,
    val actualEmail: String,
    val name: String,
    val password: String?
)

@Serializable
data class RemoveOrganisationUserRequest(val userEmail: String)

enum class OrganisationUserRole {
    Owner,
    User,
    Invited
}

@Serializable
data class OrganisationUser(
    val email: String,
    val name: String,
    val organisationUserRole: OrganisationUserRole
) : Comparable<OrganisationUser> {
    companion object {
        val COMPARATOR = compareBy<OrganisationUser> { it.organisationUserRole }.thenBy { it.name }
    }

    override fun compareTo(other: OrganisationUser) = COMPARATOR.compare(this, other)
}

@Serializable
data class User(
    val email: String,
    val name: String,
    val organisations: List<String>
)

//data class
